(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stock-shipping-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('laydown-delivery-estimate')) {
    customElements.define(
      'laydown-delivery-estimate',
      class LaydownDeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const minimum = Number.parseInt(this.dataset.minDays, 10);
          const maximum = Number.parseInt(this.dataset.maxDays, 10);
          const fulfillmentDays = Number.parseInt(this.dataset.fulfillmentBusinessDays, 10);
          const cutoffHour = Number.parseInt(this.dataset.orderCutoffHour, 10);

          if (![minimum, maximum, fulfillmentDays, cutoffHour].every(Number.isFinite)) return;

          // Preparation and transit use the manual checkout calendar.
          const originTime = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.originTimeZone,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', hourCycle: 'h23'
          }).formatToParts(new Date());
          const value = (type) => Number(originTime.find((part) => part.type === type)?.value);
          const start = new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
          if (Number.isNaN(start.getTime())) return;

          const processingStart = value('hour') >= cutoffHour || !this.isBusinessDay(start)
            ? this.addBusinessDays(start, 1)
            : start;
          const dispatch = this.addBusinessDays(processingStart, fulfillmentDays);
          const earliest = this.addBusinessDays(dispatch, minimum);
          const latest = this.addBusinessDays(dispatch, maximum);
          const format = new Intl.DateTimeFormat('en-US', {
            month: 'short', day: 'numeric', timeZone: 'UTC'
          });

          this.textContent = `${format.format(earliest)} - ${format.format(latest)}`;
        }

        isBusinessDay(date) {
          const day = date.getUTCDay();
          if (day === 0 || day === 6) return false;
          const year = date.getUTCFullYear();
          this.holidayYears ??= new Map();
          if (!this.holidayYears.has(year)) {
            const a = year % 19;
            const b = Math.floor(year / 100);
            const c = year % 100;
            const d = Math.floor(b / 4);
            const e = b % 4;
            const f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3);
            const h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4);
            const k = c % 4;
            const l = (32 + 2 * e + 2 * i - h - k) % 7;
            const m = Math.floor((a + 11 * h + 22 * l) / 451);
            const month = Math.floor((h + l - 7 * m + 114) / 31);
            const easterDay = ((h + l - 7 * m + 114) % 31) + 1;
            const easter = new Date(Date.UTC(year, month - 1, easterDay, 12));
            const fixed = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];
            const holidays = new Set(fixed.map((value) => year + '-' + value));
            for (const offset of [1, 39, 50]) {
              const holiday = new Date(easter);
              holiday.setUTCDate(holiday.getUTCDate() + offset);
              holidays.add(holiday.toISOString().slice(0, 10));
            }
            this.holidayYears.set(year, holidays);
          }
          return !this.holidayYears.get(year).has(date.toISOString().slice(0, 10));
        }

        addBusinessDays(start, amount) {
          const date = new Date(start);
          let remaining = amount;
          while (remaining > 0) {
            date.setUTCDate(date.getUTCDate() + 1);
            if (this.isBusinessDay(date)) remaining -= 1;
          }
          return date;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
